<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Detalhes da Marca</p>
        </div>

        <div class="muven-content">
            <Breadcrumb :items="breadcrumbList" class="mb-3"/>

            <div class="mb-3" v-if="!loading">
                <button class="btn btn-outline-primary mr-3"
                    @click="gotoModification(brand)">
                    Editar
                </button>

                <button class="btn btn-outline-secondary mr-3"
                    @click="forceChannelsSync(brand)"
                    :disabled="forcingChannelSync">
                    Forçar sincronização

                    <Loading v-show="forcingChannelSync" />
                </button>

                <a class="btn btn-outline-secondary"
                    :href="getAuditUrl(brand.id, EntityEnum.Brand)" target="_blank">
                    Ir para auditoria
                    <fa icon="external-link-alt" class="muven-external-link ml-1" />
                </a>
            </div>

            <Loading page v-if="loading" />            

            <div v-if="!loading">
                <div class="muven-column-layout">
                    <div class="muven-column-left">
                        <div class="muven-card mb-3">
                            <div class="muven-card-title">
                                <p>{{brand.name}}</p>
                            </div>

                            <div class="row">
                                <div class="col-12 mb-3">
                                    <label>Título</label>
                                    <p>{{brand.title | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 mb-3">
                                    <label>Descrição</label>
                                    <p>{{brand.description | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12 mb-3">
                                    <label>Palavras chave</label>
                                    <p>{{brand.keywords | infoOrPlaceholder}}</p>
                                </div>

                                <div class="col-12">
                                    <label>Status</label>                                    
                                    <p>
                                        <span v-if="brand.isActive">Ativa</span>
                                        <span v-if="!brand.isActive">Inativa</span>
                                    </p>
                                </div>
                            </div>
                        </div>              
                    </div>            

                    <div class="muven-column-right">
                        <div class="muven-card mb-3">
                            <div class="muven-card-title">
                                <p>Integração</p>
                            </div>

                            <div>
                                <div>
                                    <label>Id retaguarda</label>
                                    <p>{{brand.idSource | infoOrPlaceholder}}</p>
                                </div>                          

                                <div class="mt-3" v-for="(brandChannel, index) in brand.channels" :key="index"> 
                                    <label>Id {{brandChannel.channel.name}}</label>
                                    <p>{{brandChannel.idExternalChannel | infoOrPlaceholder}}</p>
                                </div>
                            </div>
                        </div>                    
                    </div>                     
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import brandService from '@/brand/services/BrandService'
import { infoOrPlaceholder } from '@/utils/filters/InformationOrPlaceholderFilter'
import { BrandModel } from '@/brand/models/BrandModel'
import { EntityEnum } from '@c2b/muven-commons'
import GetAuditUrl from '@/utils/mixins/GetAuditUrl'

export default {
    name: 'BrandView',
    data() {
        return {
            EntityEnum,
            loading: true,
            forcingChannelSync: false,
            brand: new BrandModel(),
            breadcrumbList: [
                {
                    id: 0,
                    description: 'Marcas',
                    path: '/marcas',
                },
                {
                    id: 1,
                    description: `Detalhes de #${this.$route.params.id}`,
                    path: '',
                },
            ],    
        }
    },
    mixins: [
        GetAuditUrl,
    ],
    filters: {
        infoOrPlaceholder,
    },
    methods: {
        async allowExportModifiedInBrand(allowExport) {
           try {
                await brandService.updateAllowExportInBrand(this.brand.id, allowExport)
           } catch (e) {
               this.$floatingAlert.error({
                   message: e.message,
               })
           }
        },
        gotoModification(brand) {
            this.$router.push(`/marcas/${brand.id}/edicao`)
        },
        async forceChannelsSync(brand) {
            this.forcingChannelSync = true

            try {
                await brandService.forceChannelsSync(brand.id)
                this.$floatingAlert.info({
                    message: `Solicitação de sincronização da marca <b>${brand.name}</b> registrado com sucesso.`,
                    timeVisible: 10000,
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message || `Houve um problema no momento de forçar a sincronização da marca <b>${brand.name}</b>. Tente novamente mais tarde.`  
                })
            }

            this.forcingChannelSync = false
        },
    },
    async mounted() {
        try {
            this.brand = await brandService.getBrandById(this.$route.params.id)
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
}
</script>
